import { makeStyles } from 'tss-react/mui';
import { link } from '../../styles/jss/utils';
import { colors, fontWeights, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    container: {
        color: colors.supplementary.black,
    },
    heading: {
        marginBottom: spacing.small,
    },
    underline: {
        textDecoration: 'underline',
    },
    email: Object.assign(Object.assign({}, theme.typography.medium_bold), { marginBottom: spacing.small, [theme.breakpoints.up('sm')]: Object.assign({}, theme.typography.large_bold) }),
    receiveOffersCheckbox: {
        marginBottom: spacing.medium,
    },
    link: Object.assign(Object.assign({}, link(theme.isFlyingFlowers ? undefined : colors.primary.gold4)), { display: 'inline' }),
    preferencesContainer: {
        paddingBottom: spacing.small,
    },
    chooseText: Object.assign(Object.assign({}, theme.typography.small_bold), { color: colors.grey.grey6, margin: `${spacing.small} 0`, maxWidth: '420px' }),
    privacyLinks: Object.assign(Object.assign({}, theme.typography.small_bold), { color: colors.grey.grey6, fontWeight: fontWeights.regular, marginBottom: spacing.medium }),
    savingText: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.grey.grey6, marginBottom: spacing.small }),
    error: { marginBottom: spacing.small },
    success: { marginBottom: spacing.small },
    buttons: {},
}));
export default useStyles;
